import { render, staticRenderFns } from "./RegisterPlayer.vue?vue&type=template&id=5f551e89&scoped=true&"
import script from "./RegisterPlayer.vue?vue&type=script&lang=js&"
export * from "./RegisterPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPlayer.vue?vue&type=style&index=0&id=5f551e89&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f551e89",
  null
  
)

export default component.exports